import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {DetectMethodChanges, isValidNumber} from "../utils";
import {ToastrService} from "ngx-toastr";
import {AtmStrikeService} from "../common-services/atm-strike-service/atm-strike.service";

@Component({
    selector: 'ets-override-atm-dialog',
    templateUrl: 'override-atm-dialog.component.html',
    styleUrls: ['override-atm-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class OverrideAtmDialogComponent implements OnInit {
    constructor(
        private readonly _changeDetector: ChangeDetectorRef,
        private readonly _toastr: ToastrService,
        private readonly _atmService : AtmStrikeService
    ) {
    }

    private _rejecter: (reason?: any) => void;
    private _resolver: (number?: number) => void;

    title = "Provide Override ATM";

    visible = false;

    overrideAtm : number;

    get currentAtm() : number {
        return this._atmService.getCurrentAtm('SPX');
    }

    ngOnInit() {
    }

    // The box opens EMPTY on every show; it does not keep the value typed on an earlier show.
    // (The 2026-09-08 zone prefill was superseded the same day: ORION no longer shows this dialog.)
    // CR-20260927-003: a caller may pre-fill the box (the zone-drift one-shot passes the card's
    // zone, unrounded - the engine handles strikes). No argument = empty, as before.
    @DetectMethodChanges()
    async show(prefill?: number) : Promise<number> {
        this.overrideAtm = isValidNumber(prefill, true) ? prefill : undefined;
        this.visible = true;
        return new Promise<number>((res, rej) => {
            this._resolver = res;
            this._rejecter = rej;
        });
    }

    @DetectMethodChanges()
    useMarketAtmClicked() {
        this._rejecter();
        this.visible = false;
    }

    @DetectMethodChanges()
    useCustomAtmClicked() {
        if (!isValidNumber(this.overrideAtm)) {
            this._toastr.error('Please, provide valid override ATM');
            return;
        }
        this._resolver(this.overrideAtm);
        this.visible = false;
    }

    onHidden() {
        this._resolver = null;
        this._rejecter = null;
    }

    onInitialized($event: any) {
        $event?.component?.registerKeyHandler('escape', (args) => args?.stopPropagation());
    }
}